module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parts",
    attrs: {
      "id": "PARTS-SWF"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible),
      expression: "mask_visible"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.platform == 'qt') ? _c('psocket', {
    attrs: {
      "attributes": _vm.attributes,
      "flashvars": _vm.flashvars
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('ul', {
    staticClass: "l1 clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("部件状态")]), _vm._v(" "), _c('ul', {
    staticClass: "l2 clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52019b9f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parts/Parts.vue
// module id = 391
// module chunks = 0